import { useTypedSelector } from 'redux/rootReducer'
import { selectUserData } from './selector'

export const useTalentProfileId = () => {
  const user = useTypedSelector(selectUserData)
  return String(user?.talentProfile?.id)
}
